<template>
  <div class="compare-chart">
    <div class="chart-title">{{ title }}</div>
    <VChart
      v-if="hasData"
      :key="metrics.map((m) => m.field).join('+')"
      class="chart"
      :option="option"
      autoresize
    />
    <div v-else class="chart-empty">{{ emptyText }}</div>
  </div>
</template>

<script>
import { computed } from 'vue';
import VChart from '@/components/charts/echarts';

export default {
  name: 'LogistsCompareChart',
  components: { VChart },
  props: {
    title: { type: String, default: '' },
    rows: { type: Array, default: () => [] },
    metrics: { type: Array, default: () => [] },
    emptyText: { type: String, default: 'Нет данных по выбранным фильтрам' },
  },
  setup(props) {
    const hasData = computed(
      () => props.rows.length > 0 && props.metrics.length > 0
    );

    const option = computed(() => {
      const metrics = props.metrics;
      const rows = props.rows;
      const names = rows.map((row) => row.logist || '—');
      const formatters = metrics.map((m) => m.formatter);
      return {
        grid: { left: 8, right: 76, top: 24, bottom: 4, containLabel: true },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          confine: true,
          formatter: (params) => {
            const list = Array.isArray(params) ? params : [params];
            const lines = list.map(
              (p) =>
                `${p.marker} ${p.seriesName}: <b>${formatters[p.seriesIndex](p.value)}</b>`
            );
            return `${list[0].name}<br/>${lines.join('<br/>')}`;
          },
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            formatter: (v) => formatters[0](Math.abs(v)),
          },
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: names,
          axisLabel: { width: 190, overflow: 'truncate' },
        },
        series: metrics.map((metric) => ({
          name: metric.label,
          type: 'bar',
          data: rows.map((row) => Number(row[metric.field]) || 0),
          itemStyle: { color: metric.color },
          barMaxWidth: 18,
          label: {
            show: true,
            position: 'right',
            formatter: (p) => metric.formatter(p.value),
          },
        })),
      };
    });

    const chartHeight = computed(() => {
      const perRow = props.metrics.length > 1 ? 32 : 26;
      return Math.max(160, props.rows.length * perRow + 60);
    });

    return { hasData, option, chartHeight };
  },
};
</script>

<style scoped>
.compare-chart {
  min-width: 0;
}

.chart-title {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #344054;
}

.chart {
  width: 100%;
  height: v-bind(chartHeight + 'px');
}

.chart-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #98a2b3;
  font-size: 14px;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
}
</style>
